import { Breakpoint } from '@wix/form-fields';
import classNames from 'classnames';
import React, { forwardRef, useState, useMemo, useCallback } from 'react';
import { TRANSLATIONS_NAMESPACE } from '../../constants/translations';
import { isSubmissionLimitReached } from '../../services/submission-limit-per-user';
import { FormRoot } from '../form';
import { DisabledFormOverlay } from './disabled-form-overlay';
import { FormViewerProvider } from './form-viewer-provider';
import styles from './form-viewer-static.module.scss';
export const FormViewerStatic = /*#__PURE__*/ forwardRef(({ form, i18n, isMobile, isRTL, config = null, readOnly = false, externalData, bi, biFormFillSessionId, translations, localeDataset, forcedState, httpClient, panorama, experiments, currency, fields, RicosViewer, breakpoint = Breakpoint.LARGE, allowFormDisable = true, fieldInitialData, validationMode, enableAnimations, ...rest }, forwardedRef)=>{
    const { language = 'en', regionalFormat = 'en', userData, visitorId } = config || {};
    useState(()=>{
        translations && i18n.addResources(language, TRANSLATIONS_NAMESPACE, translations);
        localeDataset && i18n.addResources(language, TRANSLATIONS_NAMESPACE, localeDataset);
    });
    const [isDisabledPerVisitor, setIsDisabledPerVisitor] = useState(()=>isSubmissionLimitReached({
            formId: form?.id,
            submissionLimitPerUser: form?.limitationRule?.submissionLimitPerUser,
            memberId: userData?.id,
            visitorId
        }));
    const recheckSubmissionLimit = useCallback(()=>{
        setIsDisabledPerVisitor(isSubmissionLimitReached({
            formId: form?.id,
            submissionLimitPerUser: form?.limitationRule?.submissionLimitPerUser,
            memberId: userData?.id,
            visitorId
        }));
    }, [
        form?.id,
        form?.limitationRule?.submissionLimitPerUser,
        userData?.id,
        visitorId
    ]);
    const formWithValidSteps = useMemo(()=>({
            ...form,
            steps: form?.steps?.filter((step)=>step.layout?.large?.items?.length) || []
        }), [
        form
    ]);
    if (!form || !formWithValidSteps.steps?.length) {
        return null;
    }
    const isDisabled = Boolean(allowFormDisable && (formWithValidSteps.properties?.disabled || isDisabledPerVisitor));
    return /*#__PURE__*/ React.createElement(React.StrictMode, null, /*#__PURE__*/ React.createElement(FormViewerProvider, {
        httpClient: httpClient,
        i18n: i18n,
        bi: bi,
        panorama: panorama,
        biFormFillSessionId: biFormFillSessionId,
        form: formWithValidSteps,
        language: language,
        regionalFormat: regionalFormat,
        isRTL: isRTL,
        isMobile: isMobile,
        isEditor: config?.isEditor,
        isComposer: config?.isComposer,
        externalData: externalData,
        forcedState: forcedState,
        instance: config?.instance,
        experiments: experiments,
        translationNamespace: TRANSLATIONS_NAMESPACE,
        currency: currency,
        userData: userData,
        WixRicosViewer: RicosViewer,
        addressTemplates: config?.addressTemplates,
        atlasBaseUrl: config?.atlasBaseUrl,
        fieldInitialData: fieldInitialData,
        compId: config?.compId,
        enableAnimations: enableAnimations,
        baseUrl: config?.baseUrl
    }, /*#__PURE__*/ React.createElement("form", {
        "aria-label": formWithValidSteps.properties?.name ?? '',
        id: `form-${formWithValidSteps.id}`,
        "data-hook": `form-${formWithValidSteps.id}`,
        className: classNames({
            [styles.readOnly]: readOnly,
            [styles.disabled]: isDisabled && !config?.isEditor
        }),
        onSubmit: (e)=>e.preventDefault()
    }, isDisabled && /*#__PURE__*/ React.createElement(DisabledFormOverlay, {
        content: formWithValidSteps.disabledFormMessage,
        isEditor: config?.isEditor
    }), /*#__PURE__*/ React.createElement("fieldset", {
        className: styles.fieldsetReset,
        disabled: readOnly || isDisabled
    }, /*#__PURE__*/ React.createElement(FormRoot, {
        form: formWithValidSteps,
        fields: fields,
        forwardedRef: forwardedRef,
        config: config,
        breakpoint: breakpoint,
        validationMode: validationMode,
        onSubmissionLimitReached: recheckSubmissionLimit,
        ...rest
    })))));
});

//# sourceMappingURL=form-viewer-static.js.map